import { render, staticRenderFns } from "./SortingSelect.vue?vue&type=template&id=b519d20e&scoped=true&"
import script from "./SortingSelect.vue?vue&type=script&lang=js&"
export * from "./SortingSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b519d20e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\PhpstormProjects\\warehouse\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b519d20e')) {
      api.createRecord('b519d20e', component.options)
    } else {
      api.reload('b519d20e', component.options)
    }
    module.hot.accept("./SortingSelect.vue?vue&type=template&id=b519d20e&scoped=true&", function () {
      api.rerender('b519d20e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "web/typo3conf/ext/ig_warehouse/Resources/Public/Src/JavaScript/components/form/SortingSelect.vue"
export default component.exports